<ng-container *ngIf="projects?.length; else noRecords">
  <mat-progress-bar class="loading-progress-bar" *ngIf="isLoading" [mode]="'indeterminate'"> </mat-progress-bar>
  <div class="header">
    <div class="left">
      <mat-form-field class="flex-auto gt-xs:pr-3">
        <mat-select [placeholder]="'Sort'" [value]="selectedSortField" (selectionChange)="changeSortOptions($event)">
          <mat-option *ngFor="let fieldDef of sortFields" [value]="fieldDef.name">
            {{ fieldDef.label }}
          </mat-option>
        </mat-select>
        <mat-icon matPrefix [svgIcon]="'sort'"></mat-icon>
      </mat-form-field>
    </div>
    <div class="pagination" *ngIf="showPagingControls">
      <div class="info">
        <span>{{ pagination.startIndex + 1 }}</span>
        <span class="separator">-</span>
        <span>{{ pagination.endIndex }}</span>
        <span class="separator"> of </span>
        <span>{{ pagination.length }}</span>
      </div>

      <button class="previous-page" mat-icon-button [disabled]="canGoToPreviousPage" (click)="changePage('previous')">
        <mat-icon [svgIcon]="'arrow_back_ios'"></mat-icon>
      </button>

      <button class="next-page" mat-icon-button [disabled]="canGoToNextPage" (click)="changePage('next')">
        <mat-icon [svgIcon]="'arrow_forward_ios'"></mat-icon>
      </button>
    </div>
  </div>

  <div class="list">
    <ng-container *ngFor="let project of projects; let i = index">
      <a class="item" [routerLink]="['', { outlets: { modal: ['pd', pipeline.id, project.id] } }]">
        <div class="thumbnail flex-auto w-1/3">
          <img
            *ngIf="project.featured_image_url"
            [src]="project.featured_image_url"
            onerror="this.onerror=null;this.src='https://termsheet-cdn.s3.amazonaws.com/placeholder.jpg';"
            alt="project.title"
          />
          <span *ngIf="!project.featured_image_url"> No Image </span>
        </div>
        <div class="item-content flex-auto w-2/3">
          <div class="info">
            <div class="name">
              {{ project.title?.trim() }}
            </div>

            <div class="date">
              {{ project.created_at | date: 'LLL dd, y' }}
            </div>
          </div>

          <div class="subject">
            <span>{{ project.address_string }}</span>
          </div>

          <div class="excerpt">
            {{ project.property_type?.name }}
          </div>

          <div class="excerpt" *ngIf="project.unit_size > 0">Units: {{ project.unit_size }}</div>
          <div class="excerpt" *ngIf="project.broker_guidance_price > 0">
            Asking: {{ project.broker_guidance_price | tsCurrency: 'USD':'symbol':'1.0' }}
          </div>
        </div>
      </a>
    </ng-container>
  </div>
</ng-container>

<ng-template #noRecords>
  <div class="no-mails">
    <mat-icon [svgIcon]="'iconsmind:mailbox_empty'"></mat-icon>
    <h4>There are no deals</h4>
  </div>
</ng-template>
